export const rows = [
  {
    landNumber: 134,
    landType: "Water",
    nftTraits: "Large Land\nSmall House\nDense\nCoop",
    boosts: "2x Forestry Tiki",
    resources: "T3 Trees",
    craftingStations: "10x T4 Metalworking",
    animals: "5x Sluggery\nChicken",
    status: "Public"
  },
  {
    landNumber: 152,
    landType: "Grass",
    nftTraits: "Large Land\nSmall House\nDense\nCoop",
    boosts: "2x Forestry Tiki",
    resources: "T2 Trees",
    craftingStations: "10x T4 Metalworking",
    animals: "5x Sluggery\nChicken",
    status: "Public"
  },
  {
    landNumber: 777,
    landType: "Water",
    nftTraits: "Large Land\nSmall House\nCoop\nSilo\nWindmill",
    boosts: "2x Farming Ice\n2x Animal Care Tiki\n2x Mining Tiki\n2x Golden Snake Sculpture",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "",
    animals: "Chicken",
    status: "Public"
  },
  {
    landNumber: 778,
    landType: "Water",
    nftTraits: "Large Land\nSmall House\nDense\nCoop",
    boosts: "2x Forestry Tiki\n2x Animal Care Tiki",
    resources: "T4 Trees",
    craftingStations: "10x T4 Woodworking",
    animals: "5x Sluggery\nChicken",
    status: "Public"
  },
  {
    landNumber: 1288,
    landType: "Water",
    nftTraits: "Large Land\nSmall House",
    boosts: "2x Farming Ice\n2x Mining Ice",
    resources: "T4 Mines",
    craftingStations: "8x Space BBQ\n7x Water BBQ\n8x Improved Sushi Kit",
    animals: "5x Sluggery",
    status: "Private"
  },
  {
    landNumber: 1565,
    landType: "Space",
    nftTraits: "Large Land\nSmall House\nSilo",
    boosts: "2x Mining Tiki",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "10x T4 Kiln",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 1792,
    landType: "Grass",
    nftTraits: "Large Land\nSmall House\nCoop",
    boosts: "",
    resources: "T4 Soils",
    craftingStations: "10x T4 Metalworking\n5x Elite Sushi Kit",
    animals: "5x Sluggery\nChicken",
    status: "Private"
  },
  {
    landNumber: 2159,
    landType: "Space",
    nftTraits: "Large Land\nLarge House\nSilo",
    boosts: "2x Mining Tiki",
    resources: "T4 Mines\nT5 Mines\n3x Ponds",
    craftingStations: "10x T4 Kiln",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 2217,
    landType: "Water",
    nftTraits: "Large Land\nSmall House\nSilo\nWindmill",
    boosts: "2x Mining Ice\n2x Animal Care Tiki\n2x Mining Tiki",
    resources: "T4 Mines\nT5 Mines\n3x Ponds",
    craftingStations: "10x T4 Metalworking",
    animals: "8x Lil Bo Sheep\n8x Turkey",
    status: "Public"
  },
  {
    landNumber: 2218,
    landType: "Grass",
    nftTraits: "Large Land\nLarge House\nDense\nCoop\nSilo\nWindmill",
    boosts: "2x Forestry Tiki\n2x Animal Care Tiki",
    resources: "T4 Trees\nT5 Trees\n3x Ponds",
    craftingStations: "10x T4 Woodworking",
    animals: "6x Apiary\n1x Goat\n1x Dragon\n7x Hunkin' Heifer\nChicken",
    status: "Public"
  },
  {
    landNumber: 2311,
    landType: "Grass",
    nftTraits: "Large Land\nLarge House\nWindmill",
    boosts: "2x Metalworking Ice",
    resources: "T4 Mines",
    craftingStations: "T2 Metalworking",
    animals: "",
    status: "Public"
  },
  {
    landNumber: 2313,
    landType: "Grass",
    nftTraits: "Large Land\nLarge House\nSilo\nWindmill",
    boosts: "2x Farming Tiki",
    resources: "T1 Soils\n3x Ponds",
    craftingStations: "T2 Woodworking",
    animals: "",
    status: "Public"
  },
  {
    landNumber: 2811,
    landType: "Water",
    nftTraits: "Small Land\nLarge House\nCoop\nSilo\nWindmill",
    boosts: "2x Farming Ice\n2x Mining Ice",
    resources: "2x Ponds",
    craftingStations: "10x T4 Woodworking",
    animals: "3x Sluggery\nChicken",
    status: "Public"
  },
  {
    landNumber: 2905,
    landType: "Water",
    nftTraits: "Large Land\nSmall House\nSilo\nWindmill",
    boosts: "2x Mining Ice",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "10x T4 Woodworking",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 3170,
    landType: "Grass",
    nftTraits: "Large Land\nLarge House\nCoop\nWindmill",
    boosts: "2x Windmill Ice\n2x Woodworking Ice",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "15x Water BBQ",
    animals: "Chicken",
    status: "Private"
  },
  {
    landNumber: 3196,
    landType: "Water",
    nftTraits: "Large Land\nSmall House\nCoop\nSilo\nWindmill",
    boosts: "2x Mining Ice",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "",
    animals: "5x Sluggery\nChicken",
    status: "Public"
  },
  {
    landNumber: 3236,
    landType: "Grass",
    nftTraits: "Large Land\nLarge House\nSilo\nWindmill",
    boosts: "2x Farming Tiki",
    resources: "T4 Soils\nT5 Soils\n3x Ponds",
    craftingStations: "10x T4 Metalworking",
    animals: "",
    status: "Public"
  },
  {
    landNumber: 3338,
    landType: "Grass",
    nftTraits: "Large Land\nLarge House",
    boosts: "2x Farming Tiki",
    resources: "T4 Soils\n3x Ponds",
    craftingStations: "10x T4 Woodworking",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 3743,
    landType: "Space",
    nftTraits: "Large Land\nSmall House\nSilo",
    boosts: "2x Mining Tiki\n2x Stoneshaping Ice\n2x Leprechaun Sculpture",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "10x T4 Kiln",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 4401,
    landType: "Space",
    nftTraits: "Large Land\nLarge House",
    boosts: "2x Mining Tiki\n2x Golden Snake Sculpture",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "10x T4 Kiln",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 4762,
    landType: "Grass",
    nftTraits: "Large Land\nLarge House\nSilo\nWindmill",
    boosts: "2x Woodworking Ice\n2x Mining Ice",
    resources: "T4 Soils\n3x Ponds",
    craftingStations: "",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 4838,
    landType: "Water",
    nftTraits: "Large Land\nSmall House\nWindmill",
    boosts: "2x Metalworking Ice\n2x Farming Ice\n2x Woodworking Ice",
    resources: "T4 Soils\n3x Ponds",
    craftingStations: "10x T4 Metalworking",
    animals: "5x Sluggery",
    status: "Public"
  },
  {
    landNumber: 4878,
    landType: "Space",
    nftTraits: "Large Land\nSmall House",
    boosts: "2x Mining Tiki\n2x Leprechaun Sculpture",
    resources: "T4 Mines\n3x Ponds",
    craftingStations: "10x T4 Kiln",
    animals: "5x Sluggery",
    status: "Public"
  }
];